import React from 'react';
import { Helmet } from 'react-helmet-async';

const SITE = 'https://360moldservices.ca';

const Seo = ({ title, description, path = '', schema }) => {
  const fullTitle = title
    ? `${title} | 360 Mold Services`
    : '360 Mold Services | Mold Inspection & Air Quality Testing in Ontario';
  const url = `${SITE}${path}`;
  return (
    <Helmet>
      <title>{fullTitle}</title>
      {description && <meta name="description" content={description} />}
      <link rel="canonical" href={url} />
      <meta property="og:title" content={fullTitle} />
      {description && <meta property="og:description" content={description} />}
      <meta property="og:url" content={url} />
      {schema && <script type="application/ld+json">{JSON.stringify(schema)}</script>}
    </Helmet>
  );
};

export default Seo;
